import React, { useState } from "react";
import LoginPage from "./LoginPage";
import McDonaldsMapApp from "./McDonaldsApp";

function App() {
  const [loggedInUser, setLoggedInUser] = useState<string | null>(null);

  return (
    <>
      {loggedInUser ? (
        <McDonaldsMapApp username={loggedInUser} />
      ) : (
        <LoginPage onLogin={setLoggedInUser} />
      )}
    </>
  );
}

export default App;
